import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from '@modifi/redux'

import {
  aEnsurePublicRegisteredCompanies,
  selectHasPublicRegisteredCompanies,
  selectPublicRegisteredCompaniesWhereLoaded,
} from '../../../data/public-registered-companies'
import {
  selectCurrentCompaniesCountryCode,
  selectCompanyName,
  selectCompanyExternalId,
} from '../../../data/company'

type UseDataPrefillLoaderResult = {pending: boolean; hasData: boolean}

const useDataPrefillLoader = (): UseDataPrefillLoaderResult => {
  const [result, setResult] = useState<UseDataPrefillLoaderResult>({pending: true, hasData: false})
  const countryCode = useSelector(selectCurrentCompaniesCountryCode)
  const companyName = useSelector(selectCompanyName)
  const externalCompanyId = useSelector(selectCompanyExternalId)

  const dataWasLoaded = useSelector(state => {
    if (countryCode && companyName) {
      return selectPublicRegisteredCompaniesWhereLoaded(state)
    }
    return false
  })
  const hasData = useSelector(state => {
    if (countryCode && companyName) {
      return selectHasPublicRegisteredCompanies(state)
    }
    return false
  })
  const dispatch = useDispatch()

  useEffect(() => {
    if (countryCode && companyName) {
      dispatch(aEnsurePublicRegisteredCompanies())
    }
  }, [dispatch, countryCode, companyName, externalCompanyId])

  useEffect(() => {
    setResult(prevRes => ({...prevRes, pending: !dataWasLoaded}))
  }, [dataWasLoaded])

  useEffect(() => {
    setResult(prevRes => ({...prevRes, hasData: !!hasData}))
  }, [hasData])

  return result
}

export default useDataPrefillLoader
